/**
 * Generates a full URL for a file import template.
 * It uses the ASSET_HOST if available (typically in production/staging),
 * otherwise, it falls back to a root-relative path for local development.
 *
 * @param {string} templateName - The name of the template file (e.g., 'members.csv').
 * @returns {string} The full URL or path to the template.
 */
export function getFileImportTemplateUrl(templateName) {
  const assetHost = typeof window !== 'undefined' && window.ASSET_HOST ? window.ASSET_HOST : '';
  // Ensure assetHost doesn't have a trailing slash if it's present
  const cleanAssetHost = assetHost.endsWith('/') ? assetHost.slice(0, -1) : assetHost;
  const basePath = '/file_import_templates'; // Path is not versioned for these specific templates as per Dockerfile

  if (cleanAssetHost) {
    return `${cleanAssetHost}${basePath}/${templateName}`;
  }

  // If no asset host, return the path relative to the root.
  return `${basePath}/${templateName}`;
}
